module.exports=[
  "Academic Department Head/Chair",
  "Analyst",
  "Business Development/Finance/Legal",
  "Clinical Researcher/Professional",
  "Consultant",
  "Executive Mgmt (CEO/Pres/VP)",
  "Group or Section Leader/Project Mgr.",
  "Lab Director/Lab Mgr./Dept. Mgr.",
  "Lab Manager",
  "Lab/Research Manager",
  "Other",
  "Physician/Medical Professional",
  "Postdoctoral Fellow",
  "Principal Investigator",
  "Production/Process Engineer",
  "Professor/Assistant/ Associate Professor ",
  "Program Manager",
  "Purchasing Agent/Manager",
  "Regulatory/QA/Drug Safety Officer",
  "Research Director/VP Research/CSO",
  "Research Scientist",
  "Retired",
  "Senior Researcher",
  "Statistician",
  "Technician/Research Assistance",
  "Undergraduate Student"
]

